import { useQuery } from '@tanstack/react-query'
import { getStaffMembers } from '../services/bookingsService'

export function useStaffMembers() {
  return useQuery({
    queryKey: ['staffMembers'],
    queryFn: () => getStaffMembers(),
    staleTime: 10 * 60 * 1000,
  })
}
